import React from 'react'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { modal } from '../../core/utilities/modal'

import NavLink from '../Routes/NavLink'

import { quickBooksHandler } from '../../helpers/Integrations/QuickBooks/QuickBooksHandler'

export default class QuickBooksActions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            actionType: 'GetCustomers',
            lastRun: null
        };

    }

    componentDidMount() {
        var self = this;
        quickBooksHandler.getLastActivity(function(response) {
            self.setState({
                lastRun: response.last_run
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    runAction() {
        quickBooksHandler.runAction(this.state.actionType, function(response) {
            modal.showInfo("Request has been queued.  Once your QuickBooks asks us for information, we'll pass along the request!", "success", "top", "center");
        });
    }

    actionChange(e) {
        this.setState({
            actionType: e.target.value
        });
    }

    render(){
        const actionType    = this.state.actionType;
        const lastRun       = this.state.lastRun;
        return (
            <div class="content">
                { lastRun != null && (
                <div class="stats">
                    <i class="fa fa-clock-o"></i>
                    <span> Last sync up </span>
                    <span>{moment(lastRun).local().format('MMMM Do YYYY, h:mm a')}</span>
                </div>
                )}
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="phone">Run an Action</label>
                        <select class="form-control" value={actionType} onChange={this.actionChange.bind(this)}>
                            <option value='GetCustomers'>Get Latest Customers</option>
                            <option value='GetPayments'>Get Lease Payment History</option>
                            <option value='SendRentPayments'>Send Rent Payments from Leases</option>
                        </select>
                    </div>
                </div>
                <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.runAction.bind(this)}>
                    Run Action
                </button>
                <div class="clearfix"></div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/QuickBooks/QuickBooksActions.jsx